// Bridge between the theme system (intent-driven, imperative) and CSS rules
// that read `var(--magviz-*)`. On theme apply, sets every magviz custom
// property on :root; the rest of the chrome (css/style.css) updates for free.
//
// The same var map is generated at build time by the Vite plugin in
// vite.config.ts so first paint already has theme values — no cold-start
// flash. Keep both call sites going through `themeToCssVars` in app/themeCss.

import { themeToCssVars } from '../app/themeCss';
import type { ThemeDefaults } from '@config/defaults';

type ThemeLike = Partial<ThemeDefaults> | Record<string, unknown>;

export function applyThemeCssVars(theme: ThemeLike | null | undefined): void {
    const vars = themeToCssVars(theme || null);
    const root = document.documentElement.style;
    for (const [name, value] of Object.entries(vars)) {
        root.setProperty(name, value);
    }
}
